import React from "react";

export const BatLockup = () => (
  <svg
    viewBox="0 0 62 60"
    xmlns="http://www.w3.org/2000/svg"
    className="bat-svg"
  >
    <defs>
      <filter
        x="-36.5%"
        y="-41.7%"
        width="172.9%"
        height="183.3%"
        filterUnits="objectBoundingBox"
        id="bat-logo"
      >
        <feOffset dy="4" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="2.5"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g>
      <circle
        className="circle-delay"
        fillOpacity=".1"
        fill="#CD58EB"
        cx="16.5"
        cy="11"
        r="5"
      />
      <circle
        className="circle-delay"
        fillOpacity=".1"
        fill="#CD58EB"
        cx="49"
        cy="20"
        r="6"
      />
      <circle
        className="circle-delay"
        fillOpacity=".3"
        fill="#CD58EB"
        cx="50"
        cy="50"
        r="5"
      />
      <circle
        className="circle-delay"
        fillOpacity=".3"
        fill="#CD58EB"
        cx="2"
        cy="50"
        r="2"
      />
      <circle
        className="circle-delay2"
        fillOpacity=".4"
        fill="#CD58EB"
        cx="9"
        cy="0"
        r="1"
      />
      <circle
        className="circle-delay2"
        fillOpacity=".6"
        fill="#CD58EB"
        cx="12"
        cy="34"
        r="4"
      />
      <circle
        className="circle-delay2"
        fillOpacity=".8"
        fill="#CD58EB"
        cx="40"
        cy="33"
        r="2"
      />
      <circle
        className="circle-delay2"
        fillOpacity=".1"
        fill="#CD58EB"
        cx="6"
        cy="66"
        r="2"
      />

      <circle
        className="circle2"
        fillOpacity=".6"
        fill="#CD58EB"
        cx="10"
        cy="14"
        r="2"
      />
      <circle
        className="circle2"
        fillOpacity=".6"
        fill="#CD58EB"
        cx="20"
        cy="3"
        r="1"
      />
      <circle
        className="circle2"
        fillOpacity=".7"
        fill="#CD58EB"
        cx="20"
        cy="17"
        r="1"
      />
      <circle
        className="circle2"
        fillOpacity=".3"
        fill="#CD58EB"
        cx="60"
        cy="24"
        r="2"
      />
      <circle
        className="circle"
        fillOpacity=".8"
        fill="#CD58EB"
        cx="3"
        cy="20"
        r="1"
      />
      <circle
        className="circle"
        fillOpacity=".4"
        fill="#CD58EB"
        cx="20"
        cy="56"
        r="1"
      />
      <circle
        className="circle"
        fillOpacity=".8"
        fill="#CD58EB"
        cx="30"
        cy="26"
        r="1"
      />
      <circle
        className="circle"
        fillOpacity=".8"
        fill="#CD58EB"
        cx="6"
        cy="11"
        r="1"
      />

      <g filter="url(#bat-logo)" transform="translate(7 6)">
        <path
          d="M.08 41.485l14.104-8.194 9.722-16.854V.187c-.257 0-.513.17-.708.506L11.682 20.657.166 40.621c-.194.337-.212.642-.085.864"
          fill="#FF4724"
        />
        <path
          d="M23.906.188v16.25l9.722 16.853 14.103 8.194c.127-.222.109-.527-.085-.864L36.13 20.657 24.613.693c-.195-.337-.451-.505-.707-.505"
          fill="#9E1F63"
        />
        <path
          d="M47.73 41.485l-14.102-8.194H14.184L.08 41.485c.127.224.4.362.79.362h46.07c.389 0 .662-.138.79-.362"
          fill="#662D91"
        />
        <path fill="#FFF" d="M14.184 33.29h19.444l-9.722-16.853z" />
      </g>
    </g>
  </svg>
);
